var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSun = function SvgSun(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#sun_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 1v3.3m0 15.4V23M4.3 4.3l2.2 2.2m11 11 2.2 2.2M1 12h3.3m15.4 0H23M6.5 17.5l-2.2 2.2M19.7 4.3l-2.2 2.2M16.4 12a4.4 4.4 0 1 1-8.8 0 4.4 4.4 0 0 1 8.8 0Z",
    stroke: "#00344E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "sun_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export { SvgSun as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzEwOTVfMTU1MTApIj4KPHBhdGggZD0iTTEyIDFWNC4zTTEyIDE5LjdWMjNNNC4zIDQuM0w2LjUgNi41TTE3LjUgMTcuNUwxOS43IDE5LjdNMSAxMkg0LjNNMTkuNyAxMkgyM002LjUgMTcuNUw0LjMgMTkuN00xOS43IDQuM0wxNy41IDYuNU0xNi40IDEyQzE2LjQgMTQuNDMwMSAxNC40MzAxIDE2LjQgMTIgMTYuNEM5LjU2OTk1IDE2LjQgNy42IDE0LjQzMDEgNy42IDEyQzcuNiA5LjU2OTk1IDkuNTY5OTUgNy42IDEyIDcuNkMxNC40MzAxIDcuNiAxNi40IDkuNTY5OTUgMTYuNCAxMloiIHN0cm9rZT0iIzAwMzQ0RSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzEwOTVfMTU1MTAiPgo8cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IndoaXRlIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==";